import { useEffect, useState } from 'react'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import styles from './AppointmentDisabilitiesHistory.module.sass'
import { API_URL } from 'store/fetchUtils'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const relationTypeMap = {
	1: 'execução',
	2: 'remarcação',
	3: 'transferência',
	4: 'anulação de consulta',
	5: 'edição manual',
}

function buildDescription(item) {
	const type = relationTypeMap[item.relationTypeId] || 'desconhecido'

	if (!item.nextAppointmentId) {
		return `Consulta #${item.appointmentId} — sem próxima consulta — tipo de relação: ${type} — ${item.user}`
	}

	return `Consulta #${item.appointmentId} — próxima consulta #${item.nextAppointmentId} — tipo de relação: ${type} — ${item.user}`
}

const AppointmentDisabilitiesHistory = ({
	appointmentId,
	processId,
	...attributes
}) => {
	const [history, setHistory] = useState([])
	const [loading, setLoading] = useState(true)
	const { i18n } = useGlobal()

	useEffect(() => {
		async function load() {
			try {
				const token = localStorage.getItem('session-token')

				const response = await fetch(
					`${API_URL}/api/clinical_processes/${processId}/appointments/${appointmentId}/next_relationship_history`,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				)
				const result = await response.json()
				const sorted = [...result].sort(
					(a, b) => new Date(a.timestamp) - new Date(b.timestamp)
				)
				setHistory(sorted)
			} catch (e) {
				console.error('Erro ao carregar histórico da consulta:', e)
			} finally {
				setLoading(false)
			}
		}

		load()
	}, [appointmentId, processId])

	if (loading) {
		return <div className={styles.loading}>{i18n`Loading...`}</div>
	}

	if (!history.length) {
		return <div className={styles.empty}>Sem histórico disponível.</div>
	}

	return (
		<div {...attributes} className={styles['history-container']}>
			<h5>Histórico da Consulta</h5>

			{history.map((item) => (
				<VStack key={item.id}>
					<VStack className={styles['history-line-container']}>
						<HStack className={styles['history-line-title']}>
							<span className={styles['history-item-circle']} />
							<h5>
								{new Date(item.timestamp).toLocaleString(
									'pt-PT'
								)}
							</h5>
						</HStack>

						<small>{buildDescription(item)}</small>
					</VStack>
				</VStack>
			))}
		</div>
	)
}

export default AppointmentDisabilitiesHistory
